module.exports = __webpack_public_path__ + "static/img/案例8.b254674.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/business/案例8.png
// module id = Z7rn
// module chunks = 0